<template>
    <div :aria-labelledby="name" class="my-2" :class="containerClass">
        <div>
            <slot></slot>
            <div :class="status ? 'error' : ''" class="input-wrapper my-2 relative rounded-md shadow-md bg-blue-light/50">
                <textarea
                    class="input block p-3 w-full appearance-none focus:outline-none bg-transparent dark:text-white"
                    :value="value"
                    :name="name"
                    :required="required"
                    :type="type"
                    :status="status"
                    placeholder=" "
                    @input="$emit('update:value', $event.target.value)"
                >
                </textarea>

                <label
                    v-if="label"
                    :for="name"
                    class="input-label pointer-events-none absolute top-0 text-blue-dark/50 p-3 duration-300 origin-0 rounded-md"
                    :class="[required ? 'after:content-[' * '] after:ml-0.5 after:text-red' : '', labelClass]"
                >
                    {{ label }}
                </label>
            </div>
        </div>
        <FormError :formComponentId="formComponentId" :name="name" v-model:status="status" />
    </div>
</template>

<script>
export default {
    props: {
        value: String,
        type: String,
        required: Boolean,
        name: String,
        label: String,
        formComponentId: '',

        labelClass: String,
        containerClass: String
    },

    emits: ['update:value'],

    data: () => ({
        status: null
    })
};
</script>
